import { api } from './client'
import type { WorkerPerformanceRanking, DepartmentPerformanceRanking } from './workerService'

export interface DashboardStats {
    total_orders: number
    inventory_items: number
    pending_tasks: number
    sales_today: number
    total_orders_change: string
    inventory_items_change: string
    pending_tasks_change: string
    sales_today_change: string
}

export interface RecentActivity {
    id: string
    action: string
    time: string
    time_str: string
    user: string
    type: 'sale' | 'task' | 'user'
}

export interface SupervisorDashboardData {
    stats: DashboardStats
    recent_activities: RecentActivity[]
    top_worker?: WorkerPerformanceRanking | null
    top_department?: DepartmentPerformanceRanking | null
}

export interface AdminDashboardData {
    metrics: {
        totalRevenue: number
        netProfit: number
        totalAnimals: number
        activeEquipment: number
        totalUsers: number
        revenueChange: string
        profitChange: string
        animalsChange: string
    }
    userDistribution: Record<string, number>
    recentActivities: RecentActivity[]
    topWorker?: WorkerPerformanceRanking | null
    topDepartment?: DepartmentPerformanceRanking | null
}


export const dashboardService = {
    getSupervisorStats: async (): Promise<SupervisorDashboardData> => {
        const response = await api.get<SupervisorDashboardData>('supervisor/dashboard/stats/')
        return response.data
    },
    getAdminStats: async (): Promise<AdminDashboardData> => {
        const response = await api.get<AdminDashboardData>('admin/dashboard/stats/')
        return response.data
    },
}
